import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

const MaxPassengerModal = ({ onClose, totalPassengerCount }) => {
  return (
    <Modal isOpen={true} id="max-passenger">
      <div className="modal-header p-3 bg-soft-danger">
        <h5 className="modal-title">Alert</h5>
      </div>

      <ModalBody>
        <h6 className=" m-0">Total passengers (number of passengers + baby seats + infants) should not be more than {totalPassengerCount}</h6>
      </ModalBody>

      <ModalFooter className="pb-0">
        <div className="modal-footer mx-auto">
          <Button color="danger" onClick={() => onClose()}>
            OK
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default MaxPassengerModal;
